/* Mobile menu burger toggle.
   The menu is a panel hanging off the nav bar rather than a full screen
   takeover, so the page behind it stays visible and tapping it is the obvious
   way to dismiss. Escape does the same for keyboards. */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    const isOpen = function () {
        return navigation.classList.contains('is-open');
    };

    const close = function () {
        navigation.classList.remove('is-open');
        document.documentElement.style.overflowY = null;
    };

    burger.addEventListener('click', function () {
        if (!isOpen()) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            close();
        }
    });

    /* The burger lives inside .gh-navigation, so its own click never reaches this */
    document.addEventListener('click', function (event) {
        if (isOpen() && !navigation.contains(event.target)) close();
    });

    document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && isOpen()) {
            close();
            burger.focus();
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();